// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__pBmN7","title":"ClientReferral_title__1JkZa","itemText":"ClientReferral_itemText__1MuOB"};